import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

interface SectionMarkerProps {
  children: ReactNode;
  /** Use the muted (architectural) variant instead of pink. */
  muted?: boolean;
  /** Hide the leading dash. */
  noDash?: boolean;
  className?: string;
}

/**
 * Architectural section marker — brand v2.3 marker tracking +0.06em.
 * Pink leading dash + uppercase Poppins 700, 10px.
 */
export const SectionMarker = ({
  children,
  muted = false,
  noDash = false,
  className,
}: SectionMarkerProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-3 font-display uppercase',
      'text-[10px] font-bold tracking-marker',
      muted ? 'text-text-muted' : 'text-pink',
      className,
    )}
  >
    {!noDash && (
      <span
        aria-hidden
        className={cn('h-px w-7', muted ? 'bg-text-muted/60' : 'bg-pink')}
      />
    )}
    {children}
  </span>
);
